module.exports = __webpack_public_path__ + "static/media/logo.cc87237d.png";